/*
 * @@Author: MuYang
 */

import {PROJECT_CODE} from '../paas/constants/index'

const APAAS_REG = /^\/apaas\//

// 获取ajax url
function getPaasAjaxUrl (url) {
  return '/' + PROJECT_CODE + url
}

export function batchHandleUrl (obj) {
  for (let key in obj) {
    if (APAAS_REG.test(obj[key].url)) {
      // obj[key].url = getPaasAjaxUrl(obj[key].url)
      obj[key].url = getPaasAjaxUrl(obj[key].url)
    }
  }
  return obj
}
